<script setup lang="ts">
import { trxWorkspaceSection } from '@/utils/trxNavigation';

const route = useRoute();
const content = useTemplateRef('content');
watch(
  [() => route.path, () => trxWorkspaceSection(route.query.section) === 'account'],
  async () => {
    await nextTick();
    if (content.value) {
      content.value.scrollTop = 0;
      content.value.scrollLeft = 0;
    }
  },
);
</script>

<template>
  <main ref="content">
    <RouterView />
  </main>
</template>
